import React from 'react';
import { observer } from 'mobx-react';
import type { ShowOrganization } from '@this/src/api/arrangement/organization_api';

type Props = {
  organization: ShowOrganization;
};

const FareOptionsForm: React.FC<Props> = ({ organization }) => {
  const wrapStyle: React.CSSProperties = {
    display: 'flex',
    flexFlow: 'column',
    marginTop: '8px'
  };

  const rowStyle: React.CSSProperties = {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'baseline',
    gap: '8px'
  };

  const qualifierInputStyle: React.CSSProperties = {
    maxWidth: '3em',
    fontFeatureSettings: 'normal',
    backgroundColor: '#eee'
  };

  const identityInputStyle: React.CSSProperties = {
    maxWidth: '7em',
    fontFeatureSettings: 'normal'
  };

  return (
    <div style={wrapStyle}>
      {organization.fareOptions.map((fareOption, i) => {
        return (
          <div key={i} style={rowStyle}>
            <label>qualifier</label>
            <div>
              <input type="text" value={fareOption.qualifier || ''} disabled style={qualifierInputStyle} />
            </div>
            <label>identity</label>
            <div>
              <input type="text" value={fareOption.identity || ''} disabled style={identityInputStyle} />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default observer(FareOptionsForm);
